import { css } from "styled-components";
import colors from "../../tokens/colors";
import { shadows } from "../../tokens/shadows";

export const tooltipVariables = css`
  --tooltip-text-color: ${colors.primary.cardanoBlue};
  --tooltip-box-shadow: ${shadows.elevation1};
  --tooltip-background-color: ${colors.primary.white};
`;
